import React, { FC } from 'react'
import * as pageUtils from './__details.utils'
import { REQUEST_CONFIGS_KEYS } from '@services/constants'
import { RadioList, SelectList } from '@utils/request'
import moment from 'moment'
import { formatStrapiText } from '@utils/methods'

const LeisureTarifsReductionDetails: FC<pageUtils.Props> = ({
	pageAssets,
	request
}) => {
	const radioListGrantForWhom: RadioList[] = [
		{
			label: pageAssets.request_form_leisureTarifs_grantForWhom_user_label,
			value: REQUEST_CONFIGS_KEYS.carSharingForWhom.firstOption,
			key: 'request_form_leisureTarifs_grantForWhom_user_label'
		},
		{
			label:
				pageAssets.request_form_leisureTarifs_grantForWhom_beneficiary_label,
			value: REQUEST_CONFIGS_KEYS.carSharingForWhom.secondOption,
			key: 'request_form_leisureTarifs_grantForWhom_beneficiary_label',
			extraText:
				pageAssets.request_form_leisureTarifs_grantForWhom_beneficiary_label_extraText
		}
	]

	const radioListMaritalStatus: RadioList[] = [
		{
			label: pageAssets?.request_form_leisureTarifs_maritalStatus_option1_label,
			value: REQUEST_CONFIGS_KEYS.maritalStatus.single,
			key: 'request_form_leisureTarifs_maritalStatus_option1_label'
		},
		{
			label: pageAssets?.request_form_leisureTarifs_maritalStatus_option2_label,
			value: REQUEST_CONFIGS_KEYS.maritalStatus.married,
			key: 'request_form_leisureTarifs_maritalStatus_option2_label'
		},
		{
			label: pageAssets?.request_form_leisureTarifs_maritalStatus_option3_label,
			value: REQUEST_CONFIGS_KEYS.maritalStatus.separated,
			key: 'request_form_leisureTarifs_maritalStatus_option3_label'
		},
		{
			label: pageAssets?.request_form_leisureTarifs_maritalStatus_option4_label,
			value: REQUEST_CONFIGS_KEYS.maritalStatus.divorced,
			key: 'request_form_leisureTarifs_maritalStatus_option4_label'
		},
		{
			label: pageAssets?.request_form_leisureTarifs_maritalStatus_option5_label,
			value: REQUEST_CONFIGS_KEYS.maritalStatus.widowed,
			key: 'request_form_leisureTarifs_maritalStatus_option5_label'
		}
	]

	const radioListChildrenCount: RadioList[] = [
		{
			label: pageAssets?.request_form_leisureTarifs_childrenCount_option1_label,
			value: REQUEST_CONFIGS_KEYS.childCount.none,
			key: 'request_form_leisureTarifs_childrenCount_option1_label'
		},
		{
			label: '1',
			value: REQUEST_CONFIGS_KEYS.childCount.one,
			key: 'request_form_leisureTarifs_childrenCount_option3_label'
		},
		{
			label: '2',
			value: REQUEST_CONFIGS_KEYS.childCount.two,
			key: 'request_form_leisureTarifs_childrenCount_option4_label'
		},
		{
			label: pageAssets?.request_form_leisureTarifs_childrenCount_option2_label,
			value: REQUEST_CONFIGS_KEYS.childCount.threeOrMore,
			key: 'request_form_leisureTarifs_childrenCount_option2_label'
		}
	]

	const radioListGender: RadioList[] = [
		{ label: '', value: '', key: '' },
		{
			label: pageAssets?.label_woman,
			value: REQUEST_CONFIGS_KEYS.genderSelect.female,
			key: 'label_woman'
		},
		{
			label: pageAssets?.label_man,
			value: REQUEST_CONFIGS_KEYS.genderSelect.male,
			key: 'label_man'
		},
		{
			label: pageAssets?.label_non_binary,
			value: REQUEST_CONFIGS_KEYS.genderSelect.nonBinary,
			key: 'label_non_binary'
		},
		{
			label: pageAssets?.label_prefer_not_to_choose,
			value: REQUEST_CONFIGS_KEYS.genderSelect.noAnswer,
			key: 'label_prefer_not_to_choose'
		}
	]

	const getLabelFromList = (list, value) => {
		return list?.find((element) => element.value == value?.toString())?.label
	}

	return (
		<>
			<h4 className={pageUtils.classes.h4}>
				{pageAssets?.request_form_leisureTarifs_firstSubStep_title}
			</h4>

			<div>
				<b>{pageAssets?.request_form_sustainableHygiene_forWhom_label}</b>
				<br />
				<p className={pageUtils.classes.paragraph}>
					{getLabelFromList(
						radioListGrantForWhom,
						request?.incidentForm?.grantForWhom
					)}
				</p>
			</div>

			<div>
				<b>{pageAssets?.request_form_leisureTarifs_maritalStatus_label}</b>
				<br />
				<p className={pageUtils.classes.paragraph}>
					{getLabelFromList(
						radioListMaritalStatus,
						request?.incidentForm?.maritalStatus
					)}
				</p>
			</div>

			<div>
				<b>{pageAssets?.request_form_leisureTarifs_childrenCount_label}</b>
				<br />
				<p className={pageUtils.classes.paragraph}>
					{getLabelFromList(
						radioListChildrenCount,
						request?.incidentForm?.childrenCount
					)}
				</p>
			</div>
			<h5 className={pageUtils.classes.h5}>
				{pageAssets?.request_form_leisureTarifs_included_people_title}
			</h5>

			<b>
				{pageAssets?.request_form_leisureTarifs_beneficiary_information_title}
			</b>

			<div style={{ marginBottom: '15px', lineHeight: '22px' }}>
				<div>
					<>
						<span>
							{request?.incidentForm?.beneficiaryFirstName +
								` ` +
								request?.incidentForm?.beneficiaryLastName}
						</span>
						<br />
						<div>
							<b>{pageAssets?.label_email}</b>
							<br />
							<span>{request?.incidentForm?.beneficiaryEmail}</span>
						</div>
						<div>
							<b>{pageAssets?.label_telephone}</b>
							<br />
							<span>{request?.incidentForm?.beneficiaryPhoneNumber}</span>
						</div>
					</>
					<div>
						<b>{pageAssets?.label_age}</b>
						<br />
						<span>{request?.incidentForm?.beneficiaryAge}</span>
					</div>
					{request?.incidentForm?.beneficiarySex && (
						<div>
							<b>{pageAssets?.label_sex}</b>
							<br />
							<span>
								{getLabelFromList(
									radioListGender,
									request?.incidentForm?.beneficiarySex
								)}
							</span>
						</div>
					)}
				</div>
			</div>

			{request?.incidentForm?.maritalStatus ==
				Number(REQUEST_CONFIGS_KEYS.maritalStatus.married) && (
				<>
					<b>
						{pageAssets?.request_form_leisureTarifs_spouse_information_title}
					</b>
					<div style={{ lineHeight: '22px' }}>
						<span>
							{request?.incidentForm?.spouseFirstName +
								` ` +
								request?.incidentForm?.spouseLastName}
						</span>
						<br />
						<div>
							<b>{pageAssets?.label_email}</b>
							<br />
							<span>{request?.incidentForm?.spouseEmail}</span>
						</div>
						<div>
							<b>{pageAssets?.label_telephone}</b>
							<br />
							<span>{request?.incidentForm?.spousePhoneNumber}</span>
						</div>
						<div>
							<b>{pageAssets?.label_age}</b>
							<br />
							<span>{request?.incidentForm?.spouseAge}</span>
						</div>
						{request?.incidentForm?.spouseSex && (
							<div>
								<b>{pageAssets?.label_sex}</b>
								<br />
								<span>
									{getLabelFromList(
										radioListGender,
										request?.incidentForm?.spouseSex
									)}
								</span>
							</div>
						)}
					</div>
				</>
			)}
			{request?.incidentForm?.childInformationList?.length! > 0 && (
				<h5 className={pageUtils.classes.h5}>
					{pageAssets?.request_form_sustainableHygiene_dependentChild_label}
				</h5>
			)}

			{request?.incidentForm?.childInformationList?.map((element, row) => (
				<>
					<h5
						className={pageUtils.classes.h5}
						style={{ fontSize: '16px', margin: '0px' }}
					>
						{formatStrapiText(
							row > 0
								? row +
										1 +
										pageAssets?.request_form_tarifsReduction_numberChild_label
								: pageAssets?.request_form_sustainableHygiene_firstChild_label
						)}
					</h5>
					<div
						style={{
							lineHeight: '22px',
							marginBottom: '10px'
						}}
					>
						<div>
							<b>{pageAssets?.label_firstName}</b>
							<br />
							<span>{element?.firstName}</span>
						</div>

						<div>
							<b>{pageAssets?.label_lastName}</b>
							<br />
							<span>{element?.lastName}</span>
						</div>

						<div>
							<b>{pageAssets?.label_age}</b>
							<br />
							<span>{element?.age}</span>
						</div>
						{element?.gender && (
							<div>
								<b>{pageAssets?.label_sex}</b>
								<br />
								<span>
									{getLabelFromList(radioListGender, element?.gender)}
								</span>
							</div>
						)}
					</div>
				</>
			))}
		</>
	)
}

export default LeisureTarifsReductionDetails
